import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import ProConfig from '@/config/config'
import CryptoJS from 'crypto-js'
import CookiesUtils from '@/common/utils/CookiesUtils'
import { Base64 } from 'js-base64'
import FuncUtils from '../utils/FuncUtils'

// 签名算法
function formatParams(params: any) {
  let result = ''
  if (params === null || params === undefined) {
    // null、undefined
    return null
  } else if (['number', 'string', 'boolean'].includes(typeof params)) {
    // 数字、字符串、布尔值
    return params.toString()
  } else if (params instanceof Array) {
    // 数组
    result += '['
    params.forEach((item, index) => {
      result += formatParams(item)
      result += ','
    })
    if (params.length > 0) {
      result = result.slice(0, -1)
    }
    result += ']'
  } else if (params instanceof Object) {
    // json
    result += '{'
    const keys = Object.keys(params)
      .sort()
      .filter((key) => params[key] !== null && params[key] !== undefined)
    keys.forEach((key, index) => {
      result += `${key}=${formatParams(params[key])}&`
    })
    if (keys.length > 0) {
      result = result.slice(0, -1)
    }
    result += '}'
  } else if (params instanceof Function) {
    // 函数
    return 'Function'
  }
  return result
}

// 32位随机字符串
function uuid32() {
  let result = ''
  const str = '0123456789abcdefghijklmnopqrstuvwxyz'
  for (let i = 0; i < 32; i++) {
    result += str[Math.floor(Math.random() * 36)]
  }
  return result
}

// 时间戳
function timestamp() {
  const timeDiff: any = localStorage.getItem('server-time-diff')
  const timeTrue = timeDiff ? timeDiff * 1000 : 0
  const time = Date.now() + timeTrue
  return parseInt((time / 1000).toString(), 10)
}

// 签名 Params
function apiParams() {
  // app-id: 1717089693594230785
  // app-name: 后台管理PC端
  // sign-key: 432f9a67fg6w
  // aes-key: 001b8aa852b9ab72
  const params = {
    path: '',
    data: null,
    appId: ProConfig.getApiKey(), // 后台提供
    signKey: '432f9a67fg6w', // 后台提供
    timestamp: timestamp(), // 时间戳 秒
    nonceStr: uuid32(), // 32位随机字符串
    accessToken: CookiesUtils.getToken() ? CookiesUtils.getToken() : null // token
  }
  return params
}

// // 签名 Headers
// export function apiHeaders(path: string) {
//   let params = apiParams()
//   params.path = path // 接口地址域名之后路径
//   let headers = {
//     appId: params.appId,
//     timestamp: params.timestamp,
//     nonceStr: params.nonceStr,
//     accessToken: params.accessToken,
//     sign: CryptoJS.MD5(formatParams(params))
//       .toString()
//       .toLowerCase()
//   }
//   return headers
// }

const service = axios.create({
  baseURL: ProConfig.getApiUrl(), // url = base url + request url
  timeout: 30000,
  withCredentials: false
  // withCredentials: true // send cookies when cross-domain requests
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    const params = apiParams()

    // 除get以外（post、put、delete）都有data、非表单 才添加
    if (config.data && !(config.data instanceof FormData)) {
      config.params = undefined
      params.data = config.data // 请求body参数
      if (config.data.$customJoint) {
        // 自定义拼接
        config.params = config.data.$customJoint
        delete config.data.$customJoint
      }
    }

    // if (config.data && !config.data.isPage) {
    //   //判断分页是否需要拼接url
    //   if (config.method == 'post' && !(config.data instanceof FormData)) {
    //     // console.log(config.data)
    //     let url = ''
    //     if (config.data.page) {
    //       url = 'pageNum=' + config.data.page
    //       delete config.data.page
    //     }
    //     if (config.data.pageSize) {
    //       if (url) {
    //         url += '&pageSize=' + config.data.pageSize
    //       } else {
    //         url = 'pageSize=' + config.data.pageSize
    //       }
    //       delete config.data.pageSize
    //     }
    //     if (config.data.orderByColumn) {
    //       if (url) {
    //         url += '&orderByColumn=' + config.data.orderByColumn
    //       } else {
    //         url = 'orderByColumn=' + config.data.orderByColumn
    //       }
    //       delete config.data.orderByColumn
    //     }
    //     if (config.data.isAsc) {
    //       if (url) {
    //         url += '&isAsc=' + config.data.isAsc
    //       } else {
    //         url = 'isAsc=' + config.data.isAsc
    //       }
    //       delete config.data.isAsc
    //     }
    //     // console.log(url)
    //     if (url) {
    //       config.url = config.url + '?' + url
    //     }
    //   }
    // }

    // get请求映射params参数 get只能拼接参数 其他有参数的情况也要拼接
    if (config.params) {
      let url = config.url + '?'
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        const part = encodeURIComponent(propName) + '='
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              const params = propName + '[' + key + ']'
              const subPart = encodeURIComponent(params) + '='
              url += subPart + encodeURIComponent(value[key]) + '&'
            }
          } else {
            url += part + encodeURIComponent(value) + '&'
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    params.path = '/manage' + decodeURI(config.url ? config.url : '') // 接口地址域名之后路径
    // console.log(params.path)
    // 请求头参数
    config.headers['current_app_id'] = params.appId // 后台提供
    config.headers['appId'] = params.appId // 后台提供
    if (params.accessToken) {
      config.headers['accessToken'] = params.accessToken
    }
    config.headers['timestamp'] = params.timestamp // 时间戳 秒
    config.headers['nonceStr'] = params.nonceStr // 32位随机字符串
    // console.log('加密前',formatParams(params))
    config.headers['sign'] = CryptoJS.MD5(formatParams(params))
      .toString()
      .toLowerCase() // 签名
    // console.log(config.headers['sign'])
    config.headers['current-user-id'] = UserModule.id
    // console.log(config.headers)
    return config
  },
  (error) => {
    Message({
      message: error,
      type: 'error',
      duration: 5
    })
    return Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // console.log(response)
    if (response.status === 200) {
      const res = response.data
      // 未设置状态码则默认成功状态
      const code = res.code || 0
      // 获取错误信息
      const msg = res.msg || '系统未知错误，请反馈给管理员'
      if (code != 0) {
        // 如果这里需要从登录 写在这里
        if (code >= 301 && code <= 312 && code != 306 || code === 412 || code === 401  || code === 411) {
          MessageBox.alert('登录状态已过期，请重新登录', msg, {
            confirmButtonText: '重新登录',
            callback: (action) => {
              UserModule.clearUserInfo()
              location.reload()
            }
          })
          return Promise.reject(new Error(msg))
        } else {
          // FuncUtils.hitMessageError(msg)
          // return Promise.reject(new Error(msg))
        }
      }
      return res
    } else {
      Message({
        message: 'status:' + response.status,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error('Error'))
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
